/* tslint:disable */
/* eslint-disable */

import React, { FunctionComponent } from 'react';
import { ViewProps } from 'react-native';
import { Svg, GProps, Path } from 'react-native-svg';
import { getIconColor } from './helper';

interface Props extends GProps, ViewProps {
  size?: number;
  color?: string | string[];
}

let PhotoO: FunctionComponent<Props> = ({ size, color, ...rest }) => {
  return (
    <Svg viewBox="0 0 1024 1024" width={size} height={size} {...rest}>
      <Path
        d="M312.889344 398.222336c-15.702016 0-28.444672-12.8-28.444672-28.444672 0-15.644672 12.742656-28.444672 28.444672-28.444672 15.700992 0 28.443648 12.8 28.443648 28.444672 0 15.644672-12.742656 28.444672-28.443648 28.444672m0-113.777664c-47.161344 0-85.334016 38.228992-85.334016 85.332992s38.172672 85.332992 85.334016 85.332992c47.16032 0 85.332992-38.228992 85.332992-85.332992s-38.172672-85.332992-85.332992-85.332992"
        fill={getIconColor(color, 0, '#333333')}
      />
      <Path
        d="M669.582336 335.531008c-11.321344-13.25568-27.249664-19.91168-43.179008-19.91168-16.156672 0-32.31232 6.883328-43.689984 20.537344L341.332992 625.77664l-73.499648-73.556992C256.681984 541.069312 242.118656 535.552 227.555328 535.552c-14.505984 0-29.070336 5.518336-40.220672 16.668672l-73.556992 73.556992V227.555328H910.22336v388.721664l-240.64-280.745984z m240.64 460.91264H113.77664v-90.22464l113.777664-113.777664 73.558016 73.556992c23.66464 23.665664 62.52032 21.844992 83.968-3.868672L626.28864 372.508672h0.113664L910.22336 703.715328v92.729344z m0-625.77664H113.77664c-31.403008 0-56.88832 25.428992-56.88832 56.88832v568.88832c0 31.403008 25.485312 56.889344 56.88832 56.889344H910.22336c31.459328 0 56.88832-25.486336 56.88832-56.88832V227.555328c0-31.459328-25.428992-56.88832-56.88832-56.88832z"
        fill={getIconColor(color, 1, '#333333')}
      />
    </Svg>
  );
};

PhotoO.defaultProps = {
  size: 18,
};

PhotoO = React.memo ? React.memo(PhotoO) : PhotoO;

export default PhotoO;
